import API from "../../../Api/API"

const api = new API()

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return
    qs.set(k, String(v))
  })
  const str = qs.toString()
  return str ? `?${str}` : ''
}

export const fetchMyAssignmentsApi = () => new API().get('/my_assignments')

export const fetchCampaignsApi = async (params = {}) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.get(`/campaigns${buildQuery(params)}`)) }
    catch (e) { reject(e) }
  })

export const fetchCampaignDetailApi = async (id) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.get(`/campaigns/${id}`)) }
    catch (e) { reject(e) }
  })

export const createCampaignApi = async (data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post('/campaigns', data)) }
    catch (e) { reject(e) }
  })

export const updateCampaignApi = async (id, data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.put(`/campaigns/${id}`, data)) }
    catch (e) { reject(e) }
  })

export const cancelCampaignApi = async (id) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.patch(`/campaigns/${id}/cancel`)) }
    catch (e) { reject(e) }
  })

export const cancelCreatorsApi = async (campaignId, proposalIds) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/campaigns/${campaignId}/cancel_creators`, { proposal_ids: proposalIds })) }
    catch (e) { reject(e) }
  })

export const deleteCampaignApi = async (id) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.delete(`/campaigns/${id}`)) }
    catch (e) { reject(e) }
  })

export const fetchProposalsApi = async (campaignId) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.get(`/campaigns/${campaignId}/proposals`)) }
    catch (e) { reject(e) }
  })

export const submitProposalApi = async (campaignId, data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/campaigns/${campaignId}/proposals`, data)) }
    catch (e) { reject(e) }
  })

export const updateProposalApi = async (proposalId, data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.put(`/proposals/${proposalId}`, data)) }
    catch (e) { reject(e) }
  })

export const fetchMyProposalsApi = async () =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.get('/proposals')) }
    catch (e) { reject(e) }
  })

export const submitMyAssignmentApi = (id, data, files) => {
  if (files && files.length > 0) {
    const fd = new FormData()
    if (data.submission_url)   fd.append('submission_url', data.submission_url)
    if (data.submission_notes) fd.append('submission_notes', data.submission_notes)
    files.forEach((f) => fd.append('files[]', f))
    return new API().put(`/my_assignments/${id}/submit`, fd)
  }
  return new API().put(`/my_assignments/${id}/submit`, data)
}

export const acceptInviteApi = async (campaignId) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/campaigns/${campaignId}/accept_invite`)) }
    catch (e) { reject(e) }
  })

export const createAcceptanceOrderApi = async (proposalId) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/proposals/${proposalId}/create_acceptance_order`)) }
    catch (e) { reject(e) }
  })

export const batchAcceptOrderApi = async (campaignId, proposalIds) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/campaigns/${campaignId}/proposals/batch_accept_order`, { proposal_ids: proposalIds })) }
    catch (e) { reject(e) }
  })

export const batchAcceptApi = async (campaignId, data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/campaigns/${campaignId}/proposals/batch_accept`, data)) }
    catch (e) { reject(e) }
  })

export const submitProposalDraftApi = async (proposalId, formDataOrData) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/proposals/${proposalId}/submit_draft`, formDataOrData)) }
    catch (e) { reject(e) }
  })

export const reviewProposalDraftApi = async (proposalId, data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/proposals/${proposalId}/review_draft`, data)) }
    catch (e) { reject(e) }
  })

export const submitProposalLiveLinksApi = async (proposalId, data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/proposals/${proposalId}/submit_live_links`, data)) }
    catch (e) { reject(e) }
  })

export const reviewProposalLiveLinksApi = async (proposalId, data) =>
  new Promise(async (resolve, reject) => {
    try { resolve(await api.post(`/proposals/${proposalId}/review_live_links`, data)) }
    catch (e) { reject(e) }
  })
 export const fetchDailyBidUsageApi = async () =>
  new Promise(async (resolve, reject) => {
    try {
      resolve(await api.get('/creator/daily_bid_usage'))
    } catch (e) {
      reject(e)
    }
  })
